import React from 'react';

export function Footer() {
    return (
        <footer style={{ zIndex: "10" }} className="p-3 footer-set">
            <strong className="text-muted">
                {"Copyright © 2021"}
            </strong>
            <a href="#">
                {"VisionCollab | Powered by TheDocApp."}
            </a>
            {'All rights reserved.'}
        </footer>
    );
}